import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { BasicConfig, Utils } from "@react-awesome-query-builder/ui";
import en_US from "antd/es/locale/en_US";
import { default as AntdWidgets } from "../widgets";
import { normalizeListValues } from "../utils/stuff";
import { generateCssVars } from "../utils/theming";
var settings = _objectSpread(_objectSpread({}, BasicConfig.settings), {}, {
  renderField: function renderField(props, _ref) {
    var RCE = _ref.RCE,
      FieldSelect = _ref.W.FieldSelect;
    return RCE(FieldSelect, props);
  },
  // renderField: (props, {RCE, W: {FieldDropdown}}) => RCE(FieldDropdown, props),
  // renderField: (props, {RCE, W: {FieldCascader}}) => RCE(FieldCascader, props),
  // renderField: (props, {RCE, W: {FieldTreeSelect}}) => RCE(FieldTreeSelect, props),

  renderOperator: function renderOperator(props, _ref2) {
    var RCE = _ref2.RCE,
      FieldSelect = _ref2.W.FieldSelect;
    return RCE(FieldSelect, props);
  },
  // renderOperator: (props, {RCE, W: {FieldDropdown}}) => RCE(FieldDropdown, props),

  renderFunc: function renderFunc(props, _ref3) {
    var RCE = _ref3.RCE,
      FieldSelect = _ref3.W.FieldSelect;
    return RCE(FieldSelect, props);
  },
  renderConjs: function renderConjs(props, _ref4) {
    var RCE = _ref4.RCE,
      Conjs = _ref4.W.Conjs;
    return RCE(Conjs, props);
  },
  renderSwitch: function renderSwitch(props, _ref5) {
    var RCE = _ref5.RCE,
      Switch = _ref5.W.Switch;
    return RCE(Switch, props);
  },
  renderButton: function renderButton(props, _ref6) {
    var RCE = _ref6.RCE,
      Button = _ref6.W.Button;
    return RCE(Button, props);
  },
  renderIcon: function renderIcon(props, _ref7) {
    var RCE = _ref7.RCE,
      Icon = _ref7.W.Icon;
    return RCE(Icon, props);
  },
  renderButtonGroup: function renderButtonGroup(props, _ref8) {
    var RCE = _ref8.RCE,
      ButtonGroup = _ref8.W.ButtonGroup;
    return RCE(ButtonGroup, props);
  },
  renderValueSources: function renderValueSources(props, _ref9) {
    var RCE = _ref9.RCE,
      ValueSources = _ref9.W.ValueSources;
    return RCE(ValueSources, props);
  },
  renderProvider: function renderProvider(props, _ref10) {
    var RCE = _ref10.RCE,
      Provider = _ref10.W.Provider;
    return RCE(Provider, props);
  },
  useConfirm: function useConfirm(_ref11) {
    var _useConfirm = _ref11.W.useConfirm;
    return _useConfirm();
  },
  renderConfirm: function renderConfirm(props, _ref12) {
    var Confirm = _ref12.W.Confirm;
    return Confirm(props);
  },
  // localization
  locale: _objectSpread({}, BasicConfig.settings.locale),
  removeInvalidMultiSelectValuesOnLoad: false,
  // can be removed manually in UI
  normalizeListValues: function normalizeListValues() {
    var _this$utils$normalize;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_this$utils$normalize = this.utils.normalizeListValues).call.apply(_this$utils$normalize, [null].concat(args));
  }
});
var widgets = _objectSpread(_objectSpread({}, BasicConfig.widgets), {}, {
  text: _objectSpread(_objectSpread({}, BasicConfig.widgets.text), {}, {
    factory: function factory(props, _ref13) {
      var RCE = _ref13.RCE,
        TextWidget = _ref13.W.TextWidget;
      return RCE(TextWidget, props);
    }
  }),
  textarea: _objectSpread(_objectSpread({}, BasicConfig.widgets.textarea), {}, {
    factory: function factory(props, _ref14) {
      var RCE = _ref14.RCE,
        TextAreaWidget = _ref14.W.TextAreaWidget;
      return RCE(TextAreaWidget, props);
    }
  }),
  number: _objectSpread(_objectSpread({}, BasicConfig.widgets.number), {}, {
    factory: function factory(props, _ref15) {
      var RCE = _ref15.RCE,
        NumberWidget = _ref15.W.NumberWidget;
      return RCE(NumberWidget, props);
    }
  }),
  price: _objectSpread(_objectSpread({}, BasicConfig.widgets.price), {}, {
    factory: function factory(props, _ref16) {
      var RCE = _ref16.RCE,
        PriceWidget = _ref16.W.PriceWidget;
      return RCE(PriceWidget, props);
    }
  }),
  multiselect: _objectSpread(_objectSpread({}, BasicConfig.widgets.multiselect), {}, {
    factory: function factory(props, _ref17) {
      var RCE = _ref17.RCE,
        _ref17$W = _ref17.W,
        AutocompleteWidget = _ref17$W.AutocompleteWidget,
        MultiSelectWidget = _ref17$W.MultiSelectWidget;
      return props.asyncFetch || props.showSearch ? RCE(AutocompleteWidget, _objectSpread(_objectSpread({}, props), {}, {
        multiple: true
      })) : RCE(MultiSelectWidget, props);
    }
  }),
  select: _objectSpread(_objectSpread({}, BasicConfig.widgets.select), {}, {
    factory: function factory(props, _ref18) {
      var RCE = _ref18.RCE,
        _ref18$W = _ref18.W,
        AutocompleteWidget = _ref18$W.AutocompleteWidget,
        SelectWidget = _ref18$W.SelectWidget;
      return props.asyncFetch || props.showSearch || props.allowCustomValues ? RCE(AutocompleteWidget, props) : RCE(SelectWidget, props);
    }
  }),
  slider: _objectSpread(_objectSpread({}, BasicConfig.widgets.slider), {}, {
    factory: function factory(props, _ref19) {
      var RCE = _ref19.RCE,
        SliderWidget = _ref19.W.SliderWidget;
      return RCE(SliderWidget, props);
    }
  }),
  "boolean": _objectSpread(_objectSpread({}, BasicConfig.widgets["boolean"]), {}, {
    factory: function factory(props, _ref20) {
      var RCE = _ref20.RCE,
        BooleanWidget = _ref20.W.BooleanWidget;
      return RCE(BooleanWidget, props);
    }
  }),
  date: _objectSpread(_objectSpread({}, BasicConfig.widgets.date), {}, {
    factory: function factory(props, _ref21) {
      var RCE = _ref21.RCE,
        DateWidget = _ref21.W.DateWidget;
      return RCE(DateWidget, props);
    }
  }),
  time: _objectSpread(_objectSpread({}, BasicConfig.widgets.time), {}, {
    factory: function factory(props, _ref22) {
      var RCE = _ref22.RCE,
        TimeWidget = _ref22.W.TimeWidget;
      return RCE(TimeWidget, props);
    }
  }),
  datetime: _objectSpread(_objectSpread({}, BasicConfig.widgets.datetime), {}, {
    factory: function factory(props, _ref23) {
      var RCE = _ref23.RCE,
        DateTimeWidget = _ref23.W.DateTimeWidget;
      return RCE(DateTimeWidget, props);
    }
  }),
  rangeslider: _objectSpread(_objectSpread({}, BasicConfig.widgets.rangeslider), {}, {
    factory: function factory(props, _ref24) {
      var RCE = _ref24.RCE,
        RangeWidget = _ref24.W.RangeWidget;
      return RCE(RangeWidget, props);
    }
  }),
  treeselect: _objectSpread(_objectSpread({}, BasicConfig.widgets.treeselect), {}, {
    factory: function factory(props, _ref25) {
      var RCE = _ref25.RCE,
        TreeSelectWidget = _ref25.W.TreeSelectWidget;
      return RCE(TreeSelectWidget, props);
    }
  }),
  treemultiselect: _objectSpread(_objectSpread({}, BasicConfig.widgets.treemultiselect), {}, {
    factory: function factory(props, _ref26) {
      var RCE = _ref26.RCE,
        TreeSelectWidget = _ref26.W.TreeSelectWidget;
      return RCE(TreeSelectWidget, _objectSpread(_objectSpread({}, props), {}, {
        treeMultiple: true
      }));
    }
  })
});
var types = _objectSpread({}, BasicConfig.types);
var ctx = _objectSpread(_objectSpread({}, BasicConfig.ctx), {}, {
  utils: _objectSpread(_objectSpread({}, BasicConfig.ctx.utils), {}, {
    normalizeListValues: normalizeListValues
  }),
  W: _objectSpread(_objectSpread({}, BasicConfig.ctx.W), AntdWidgets),
  generateCssVars: generateCssVars
});
var config = _objectSpread(_objectSpread({}, BasicConfig), {}, {
  ctx: ctx,
  types: types,
  widgets: widgets,
  settings: settings
});
config = Utils.ConfigMixins.addMixins(config, ["rangeslider", "treeselect", "treemultiselect", "rangeable__date"]);
export default config;